module.exports = __webpack_public_path__ + "static/media/our-proejcts-img4.d1c3070e.png";